<template>
	 <v-container style="padding: 0;">
		 <v-dialog title="图片预览" v-model="hideShow" width="800">
			<v-card>
				<v-card-title>
					<span>图片预览</span>
					<v-spacer></v-spacer>
					<v-icon @click="cancel">mdi-close-circle</v-icon>
				</v-card-title>
				<v-divider></v-divider>
				<v-card-text class="mt-5 d-flex align-center justify-center">
					<div>
						<template v-if="imgUrl">
							<v-img :src="imgPrev+imgUrl" :width="imgWidth" :height="imgHeight"></v-img>
						</template>
					</div>
				</v-card-text>
			</v-card>
		</v-dialog>
	 </v-container>
</template>

<script>
	import utils from "../config/utils"
	import global from "../config/global"
	export default {
		name:"image-viewer",
		props: {
			//显示/隐藏。
			show: {
				type: Boolean,
				default: false
			},
			imgSrc:{
				type:String,
				default:""
			},
			imgWidth:{
				type:String,
				default:"300"
			},
			imgHeight:{
				type:String,
				default:"300"
			}
		},
		watch:{
			show(newVal,oldVal){
				console.log("newVal",newVal);
				this.hideShow = newVal;
				this.imgUrl = this.imgSrc;
				console.log('imgUrl:',this.imgUrl);
			},
		},
		data(){
			return {
				imgPrev :global.config.imgPre,
				hideShow:this.show,
				imgUrl:this.imgSrc,
			}
		},
		mounted() {
			console.log("image-viewer mounted");
		},
		methods:{
			cancel(){
				this.$emit("cancel","");
			}
		}
	}
	
</script>

<style>
</style>
